<template>
  <div class="container">
    <div>
      <el-input v-model="nickname"
                placeholder="请输入用户名或服务名"
                clearable
                size="small"
                style="width: 250px; margin-right: 20px; margin-bottom: 10px"
                @keyup.enter.native="callback(key)"></el-input>
      <el-button type="primary"
                 icon="el-icon-search"
                 size="mini"
                 @click="callback(key)">搜索
      </el-button>
      <el-button type="primary"
                 icon="el-icon-refresh"
                 size="mini"
                 @click="resetNickname">重置
      </el-button>
    </div>
    <div>
      <a-tabs default-active-key="1"
              @change="callback">
        <a-tab-pane key="1"
                    tab="用户设置">
          <div class="table-responsive">
            <table class="table table-striped table-primary table-bordered">
              <thead>
              <tr>
                <th>用户名</th>
                <!--                <th>头像</th>-->
                <th>折扣</th>
                <th>余额</th>
                <th>操作</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in list"
                  :key="item.Id">
                <td>{{ item.nickname }}</td>
                <!--                <td>-->
                <!--                  <a-avatar :src="item.headimgurl"/>-->
                <!--                </td>-->
                <td>
                  {{
                    item.sale_rate == 0 ? 1000 : item.sale_rate | toDecimal
                  }}折
                </td>
                <td>{{ item.balance | toDecimal }}</td>
                <td>
                  <a @click="
                        show = true;
                        operated_union_id = item.id;
                      ">折扣</a>
                  <span class="margin-10">|</span>
                  <a v-if="$store.state.user.id == 6000000"
                      @click="
                        visible = true;
                        operated_union_id = item.id;
                      ">充值</a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2"
                    tab="所有订单"
                    force-render>
          <div class="table-responsive">
            <table class="table table-striped table-primary table-bordered">
              <thead>
              <tr>
                <th>创建</th>
                <th>服务</th>
                <!--                <th>服务ID</th>-->
                <th>用户名</th>
                <th v-if="$store.state.user.id == 6000000">链接</th>
                <!--                <th>下单数量</th>-->
                <!--                <th>需付</th>-->
                <!--                <th>折扣</th>-->
                <th>实付</th>
                <th>盈利</th>
                <th>状态</th>
                <!--                <th>待完成量</th>-->
                <!--                <th>余额</th>-->
                <!-- <th>充值时间</th> -->
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in list"
                  :key="item.Id">
                <td>{{ item.CreateTime }}</td>
                <td>{{ item.cn }}</td>
                <!--                <td>{{ item.services_id }}</td>-->
                <td>{{ item.nickname }}</td>
                <!--                    <td>{{ item.services_price | toDecimal }}</td>-->
                                <td v-if="$store.state.user.id == 6000000">{{ item.ApiServicesLink }}</td>
                <!--                <td>{{ item.services_num }}</td>-->
                <!--                <td>{{ item.need_amount | toDecimal }}</td>-->
                <!--                <td>{{ item.sale_rate | toDecimal }}折</td>-->
                <td>{{ item.pay_amount | toDecimal }}</td>
                <td>{{ item.profit | toDecimal }}</td>
                <td style="color: rgb(71, 102, 255)">
                  {{
                    item.ApiStatus == "" || item.ApiStatus == "Pending" || item.ApiStatus == undefined ? "处理中" : item.ApiStatus.replace("Processing", "处理中").replace("In progress", "处理中").replace("Partial", "完成部分").replace("Canceled", "退款").replace("Completed", "已完成")
                  }}
                </td>
                <!--                <td>{{ item.ApiRemains }}</td>-->
                <!--                <td>{{ item.balance | toDecimal }}</td>-->
              </tr>
              </tbody>
            </table>
          </div>
        </a-tab-pane>
<!--        <a-tab-pane key="3"-->
<!--                    tab="服务设置">-->
<!--          <div class="table-responsive">-->
<!--            <table class="table table-striped table-primary table-bordered">-->
<!--              <thead>-->
<!--              <tr>-->
<!--                <td>服务ID</td>-->
<!--                <th>服务名</th>-->
<!--                <th>原价</th>-->
<!--                <th>商品折扣</th>-->
<!--                <th>代理折扣</th>-->
<!--                <th>成本价</th>-->
<!--                <th>自定义价</th>-->
<!--                <th>自定义折扣</th>-->
<!--                <th>最终价(元/1000个)</th>-->
<!--                <th>操作</th>-->
<!--              </tr>-->
<!--              </thead>-->
<!--              <tbody>-->
<!--              <tr v-for="item in list"-->
<!--                  :key="item.Id">-->
<!--                <td>{{ item.service }}</td>-->
<!--                <td>{{ item.name }}</td>-->
<!--                <td>{{ item.base_price | toDecimal }}</td>-->
<!--                <td>{{ item.service_sale | toDecimal }}折</td>-->
<!--                <td>{{ item.agent_sale | toDecimal }}折</td>-->
<!--                <td>{{ item.agent_price | toDecimal }}</td>-->
<!--                <td>{{ item.redefine_price | toDecimal }}</td>-->
<!--                <td>{{ item.redefine_sale | toDecimal }}折</td>-->
<!--                <td>{{ item.price | toDecimal }}</td>-->
<!--                <td>-->
<!--                  <a @click="getStting(item.service)">编辑</a>-->
<!--                </td>-->
<!--              </tr>-->
<!--              </tbody>-->
<!--            </table>-->
<!--          </div>-->
<!--        </a-tab-pane>-->
        <a-tab-pane key="4" tab="所有微信充值" force-render>
          <div class="table-responsive">
            <table class="table table-striped table-primary table-bordered">
              <thead>
              <tr>
                <th>用户名</th>
                <th>内部单号</th>
                <th>微信单号</th>
                <th>支付结果</th>
                <th>支付时间</th>
                <th>金额</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in list" :key="item.Id">
                <td>{{ item.mobile }}</td>
                <td>{{ item.out_trade_no }}</td>
                <td>{{ item.transaction_id == "" ? "待支付" : item.transaction_id }}</td>
                <td>{{ item.trade_state_desc == "" ? "待支付" : item.trade_state_desc }}</td>
                <td>{{ item.success_time == "" ? "待支付" : item.success_time }}</td>
                <td>{{ item.amount | toDecimal }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </a-tab-pane>


      </a-tabs>
      <a-modal v-model="visible"
               title="用户充值"
               :confirm-loading="confirmLoading"
               @ok="handleOk"
               cancelText="取消"
               okText="确定">
        <a-form-model :layout="form.layout"
                      :model="form"
                      :rules="rules"
                      ref="ruleForm"
                      v-bind="formItemLayout">
          <a-form-model-item label="充值金额"
                             prop="amount">
            <a-input v-model="form.amount"
                     prefix="￥"
                     type="number"
                     placeholder="请填写充值金额"
                     suffix="RMB"/>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <a-modal v-model="show"
               title="折扣设置"
               :confirm-loading="confirmLoading"
               @ok="operating"
               cancelText="取消"
               okText="确定">
        <a-form-model :layout="forms.layout"
                      :model="forms"
                      :rules="rule"
                      ref="ruleForm"
                      v-bind="formItemLayout">
          <a-form-model-item label="生效日期 (折扣有效期)"
                             prop="start_time">
            <a-range-picker       :placeholder="['开始时间', '结束时间']"
                                  @change="onChange"/>
          </a-form-model-item>
          <a-form-model-item label="折扣 (例如8.8折，请输入8.8)"
                             prop="sale_rate">
            <a-input v-model="forms.sale_rate"
                     type="number"
                     placeholder="请填写折扣"/>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <a-modal v-model="stting"
               title="访问设置"
               :confirm-loading="confirmLoading"
               @ok="openSting"
               cancelText="取消"
               okText="确定">
        <a-form-model :layout="serviceForm.layout"
                      :model="serviceForm"
                      :rules="serviceRule"
                      ref="ruleForm"
                      v-bind="formItemLayout">
          <a-form-model-item label="选择时间范围"
                             prop="start_time">
            <a-range-picker @change="onChange"/>
          </a-form-model-item>
          <a-form-model-item label="自定义价格"
                             prop="sale_price">
            <a-input v-model="serviceForm.sale_price"
                     type="number"
                     placeholder="请填写价格"/>
          </a-form-model-item>
          <a-form-model-item label="自定义折扣"
                             prop="sale_rate">
            <a-input v-model="serviceForm.sale_rate"
                     type="number"
                     placeholder="请填写折扣"/>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <div class="pagein-right">
        <a-pagination v-model="current"
                      :total="total"
                      show-less-items
                      :pageSize="page_size"
                      @change="servise"/>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getUserList,
  getAllOrder,
  getRechargeOperate,
  getReduceOperate,
  getAllService,
  getRedefine,
  getAllWXPayList,
} from "@/api/mine";

export default {
  computed: {
    formItemLayout() {
      const {layout} = this.form;
      return layout === "horizontal"
          ? {
            labelCol: {span: 4},
            wrapperCol: {span: 14},
          }
          : {};
    },
    buttonItemLayout() {
      const {layout} = this.form;
      return layout === "horizontal"
          ? {
            wrapperCol: {span: 14, offset: 4},
          }
          : {};
    },
  },
  data() {
    return {
      nickname: "",
      list: [],
      page_size: 10,
      current: 1,
      total: 0,
      lists: this.$store.state.user,
      confirmLoading: false,
      visible: false, //充值
      show: false, //折扣
      stting: false, //设置
      operated_union_id: "",
      form: {
        layout: "vertical",
        amount: "",
      },
      rules: {
        amount: [
          {required: true, message: "请填写充值金额", trigger: "change"},
        ],
      },
      forms: {
        layout: "vertical",
        sale_rate: "",
        end_time: "",
        start_time: "",
      },
      rule: {
        sale_rate: [
          {required: true, message: "请填写折扣", trigger: "change"},
        ],
        start_time: [
          {required: true, message: "请选择时间范围", trigger: "change"},
        ],
      },
      serviceForm: {
        layout: "vertical",
        service_id: "",
        sale_price: "", //价格
        sale_rate: "", //折扣
        end_time: "",
        start_time: "",
      },
      serviceRule: {
        sale_price: [
          {required: true, message: "请填写价格", trigger: "change"},
        ],
        sale_rate: [
          {required: true, message: "请填写折扣", trigger: "change"},
        ],
        start_time: [
          {required: true, message: "请选择时间范围", trigger: "change"},
        ],
      },
      appSecret: "oeuednafwe52edadafdcasdwed",
      key: 1,
    };
  },
  methods: {
    callback(key) {
      this.page_size = 10;
      this.current = 1;
      this.key = key;
      if (key == 1) {
        this.getUserList();
      } else if (key == 2) {
        this.getAllOrderList();
      } else if (key == 3) {
        this.getAllServiceList();
      } else if (key == 4) {
        this.getAllWXPayOrderList();
      }
      console.log(key, this.total)
    },
    getUserList() {
      var params = {
        nickname: this.nickname,
        page: this.current,
        page_size: this.page_size,
      };
      getUserList(params).then((res) => {
        if (res.code == 200) {
          this.list = res.data.users;
          this.total = res.data.count;
        }
      });
    },
    getAllOrderList() {
      var params = {
        nickname: this.nickname,
        page: this.current,
        page_size: this.page_size,
      };
      getAllOrder(params).then((res) => {
        if (res.code == 200) {
          this.list = res.data.orders;
          this.total = res.data.count;
        }
      });
    },
    getAllServiceList() {
      var params = {
        name: this.nickname,
        page: this.current,
        page_size: this.page_size,
      };
      getAllService(params).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.list = res.data.services;
          this.total = res.data.count;
        }
      });
    },
    getAllWXPayOrderList() {
      var params = {
        name: this.nickname,
        page: this.current,
        page_size: this.page_size,
      };
      getAllWXPayList(params).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.list = res.data.re_orders;
          this.total = res.data.count;
        }
      });
    },


    resetNickname() {
      this.nickname = "";
      this.callback(this.key);
    },
    onChange(date, dateString) {
      // console.log(date, dateString);
      this.forms.start_time = dateString[0];
      this.forms.end_time = dateString[1];
      this.serviceForm.start_time = dateString[0];
      this.serviceForm.end_time = dateString[1];
    },
    // 充值
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          var params = {
            union_id: this.operated_union_id,
            amount: this.form.amount,
            sign: this.$md5(
                "unionId=" +
                this.operated_union_id +
                "&amount=" +
                this.form.amount +
                "&appSecret=" +
                this.appSecret
            ),
          };
          getRechargeOperate(params).then((res) => {
            // console.log(res);
            if (res.code == 200) {
              this.confirmLoading = false;
              this.visible = false;
              this.$message.success(res.msg);
              this.getUserList();
            } else {
              this.confirmLoading = false;
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 折扣
    operating() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          var params = {
            union_id: this.operated_union_id,
            sale_rate: this.forms.sale_rate,
            start_time: this.forms.start_time,
            end_time: this.forms.end_time,
            sign: this.$md5(
                "unionId=" +
                this.operated_union_id +
                "&sale_rate=" +
                this.forms.sale_rate +
                "&start_time=" +
                this.forms.start_time +
                "&end_time=" +
                this.forms.end_time +
                "&appSecret=" +
                this.appSecret
            ),
          };
          getReduceOperate(params).then((res) => {
            if (res.code == 200) {
              this.confirmLoading = false;
              this.show = false;
              this.$message.success(res.msg);
              this.getUserList();
            } else {
              this.confirmLoading = false;
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 设置
    openSting() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          var params = {
            service_id: this.serviceForm.service_id,
            sale_price: this.serviceForm.sale_price, //价格
            sale_rate: this.serviceForm.sale_rate, //折扣
            end_time: this.serviceForm.end_time,
            start_time: this.serviceForm.start_time,
          };
          getRedefine(params).then((res) => {
            if (res.code == 200) {
              this.confirmLoading = false;
              this.stting = false;
              this.$message.success(res.msg);
              this.callback(this.key);
            } else {
              this.confirmLoading = false;
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    getStting(id) {
      this.stting = true;
      this.serviceForm.service_id = id;
    },
    servise(e) {
      this.current = e;
      if (this.key == 1) {
        this.getUserList();
      } else if (this.key == 2) {
        this.getAllOrderList();
      } else if (this.key == 3) {
        this.getAllServiceList();
      }
    },
  },
};
</script>
<style scoped>
.marketing {
  margin-top: 80px;
}

.recharge {
  color: #ff4c34;
}

.pagein-left {
  float: left;
}

.pagein-right {
  float: right;
}

.margin-10 {
  margin: 0 10px;
}

.ant-calendar-picker {
  width: 100%;
}
</style>